import { Component, Story, Knobs, Accents, Icons } from './DocTypes';

const knobs: Knobs = {
  contentStyle: {
    editor: 'textbox',
    default: '',
  },
  colourScheme: {
    editor: 'dropdown',
    editorOptions: ['light', 'dark', ''],
    default: '',
  },
  device: {
    editor: 'dropdown',
    editorOptions: ['mobile', 'desktop', ''],
    default: '',
  },
  disableBackgroundDismiss: {
    editor: 'checkbox',
    default: false,
  },
};

const knobsReact: Knobs = {
  ...knobs,
  contentStyle: { ...knobs.contentStyle, qualifierStart: '{', qualifierEnd: '}' },
};

const BasicStory: Story = {
  title: 'Basic',
  description: 'A basic modal for mobile apps',

  coreComponent_v3: {
    html: `<tag3-mobile-modal {{...knobs}}>
  <div style='padding: 20px; display: flex; flex-direction: column;'>
    Would you like to add another?
    <div style='display: flex; flex-direction: column; align-items: stretch; margin-top: 24px; justify-content: space-between; height: 92px;' data-action='close'>
      <tag3-simple-button accent='keppel' device='mobile' button-style='{"width": "100%"}'>Yes</tag3-simple-button>
      <tag3-tertiary-button accent='keppel' device='mobile' button-style='{"width": "100%", "border": "0"}'>No</tag3-tertiary-button>
    </div>
  </div>
</tag3-mobile-modal>
<tag3-simple-button data-action='open'>Open</tag3-simple-button>
`,
    js: `var closeButton = document.querySelector('[data-action="close"]');
var modal = document.querySelector('tag3-mobile-modal');
closeButton.addEventListener("buttonClick", function () {
  modal.open = false;
});
var openButton = document.querySelector('tag3-simple-button[data-action="open"]');
openButton.addEventListener("buttonClick", function () {
  modal.open = true;
});
modal.addEventListener("openChange", function (e) {
  modal.open = e.detail.open;
});
`,
    knobs: {
      icon: {
        default: 'TickThin',
        editor: 'dropdown',
        editorOptions: [''].concat(Icons),
      },
      iconAccent: {
        default: 'keppel',
        editor: 'dropdown',
        editorOptions: [''].concat(Accents),
      },
      heading: {
        default: 'Receipt Uploaded',
        editor: 'textbox',
      },
      ...knobs,
    },
  },
  reactWrapper_v3: {
    jsx: `<Example />`,
    parentJSX: `Example = () => {
  const [open, setOpen] = React.useState(false);

  return (
    <>
      <Tag3MobileModal open={open} onOpenChange={(e) => setOpen(e.detail.open)} {{...knobs}}>
        <div style={{padding: "20px", display: "flex", flexDirection: "column"}}>
          Would you like to add another?
          <div style={{display: "flex", flexDirection: "column", alignItems: "stretch", justifyContent: "space-between", marginTop: "24px", height: "92px"}}>
            <Tag3SimpleButton accent='denim' device='mobile' onButtonClick={() => setOpen(false)} buttonStyle={{"width": "100%"}}>
              Yes
            </Tag3SimpleButton>  
            <Tag3TertiaryButton accent='denim' device='mobile' onButtonClick={() => setOpen(false)} buttonStyle={{"width": "100%", "border": "0"}}>
              No
            </Tag3TertiaryButton>
          </div>
        </div>
      </Tag3MobileModal>
      <Tag3SimpleButton
        onButtonClick={() => setOpen(true)}
      >
        Open
      </Tag3SimpleButton>
    </>
  )
}
  `,
    knobs: {
      icon: {
        default: 'TickThin',
        editor: 'dropdown',
        editorOptions: [''].concat(Icons),
      },
      iconAccent: {
        default: 'denim',
        editor: 'dropdown',
        editorOptions: [''].concat(Accents),
      },
      heading: {
        default: 'Receipt Uploaded',
        editor: 'textbox',
      },
      ...knobsReact,
    },
  },
};

const HeaderActionsStory: Story = {
  title: 'Header actions',
  description: 'A modal with a button in the header',

  coreComponent_v3: {
    html: `<tag3-mobile-modal {{...knobs}}>
  <tag3-mobile-modal-header accent='keppel'>
    <div style='position:relative;'>
      <tag3-clickable style='position: absolute; left:5px; height: 50px; display: flex; align-items: center;'>
        <tag3-icon-svg icon="ChevronLeft" accent="white"></tag3-icon-svg>
      </tag3-clickable>
    </div>
    <div style='display: flex; justify-content: center; align-items: center; height: 50px;'>
      Receipt Uploaded
    </div>
  </tag3-mobile-modal-header>
  <div style='padding: 20px; display: flex; flex-direction: column;'>
    Would you like to add another?
    <div style='display: flex; flex-direction: column; align-items: stretch; margin-top: 24px; justify-content: space-between; height: 92px;' data-action='close'>
      <tag3-simple-button accent='keppel' device='mobile' button-style='{"width": "100%"}'>Yes</tag3-simple-button>
      <tag3-tertiary-button accent='keppel' device='mobile' button-style='{"width": "100%", "border": "0"}'>No</tag3-tertiary-button>
    </div>
  </div>
</tag3-mobile-modal>
<tag3-simple-button data-action='open'>Open</tag3-simple-button>
`,
    js: `var closeButton = document.querySelector('[data-action="close"]');
var modal = document.querySelector('tag3-mobile-modal');
closeButton.addEventListener("buttonClick", function () {
  modal.open = false;
});
var openButton = document.querySelector('tag3-simple-button[data-action="open"]');
openButton.addEventListener("buttonClick", function () {
  modal.open = true;
});
modal.addEventListener("openChange", function (e) {
  modal.open = e.detail.open;
});
`,
    knobs: knobs,
  },
  reactWrapper_v3: {
    jsx: `<Example />`,
    parentJSX: `Example = () => {
  const [open, setOpen] = React.useState(false);

  return (
    <>
      <Tag3MobileModal open={open} onOpenChange={(e) => setOpen(e.detail.open)} {{...knobs}}>
        <Tag3MobileModalHeader accent='denim'>
          <div style={{position: "relative"}}>
            <Tag3Clickable style={{position: "absolute", left: "5px", height: "50px", display: "flex", alignItems: "center"}}>
              <Tag3IconSvg icon="ChevronLeft" accent="white" />
            </Tag3Clickable>
          </div>
          <div style={{display: "flex", justifyContent: "center", alignItems: "center", height: "50px"}}>
            Receipt Uploaded
          </div>
        </Tag3MobileModalHeader>
        <div style={{padding: "20px", display: "flex", flexDirection: "column"}}>
          Would you like to add another?
          <div style={{display: "flex", flexDirection: "column", alignItems: "stretch", justifyContent: "space-between", marginTop: "24px", height: "92px"}}>
            <Tag3SimpleButton accent='denim' device='mobile' onButtonClick={() => setOpen(false)} buttonStyle={{"width": "100%"}}>
              Close
            </Tag3SimpleButton>
            <Tag3TertiaryButton accent='denim' device='mobile' onButtonClick={() => setOpen(false)} buttonStyle={{"width": "100%", "border": "0"}}>
              No
            </Tag3TertiaryButton>
          </div>
        </div>
      </Tag3MobileModal>
      <Tag3SimpleButton
        onButtonClick={() => setOpen(true)}
      >
        Open
      </Tag3SimpleButton>
    </>
  )
}
  `,
    knobs: knobsReact,
  },
};

const ContentStyleStory: Story = {
  title: 'Content-Style',
  description: 'A basic modal for mobile apps using contentStyle to change the modal width',

  coreComponent_v3: {
    html: `<tag3-mobile-modal heading="Receipt Uploaded" content-style='{"width":"90%"}'>
  <div style='padding: 20px; display: flex; flex-direction: column;'>
    Would you like to add another?
    <div style='display: flex; flex-direction: column; align-items: stretch; margin-top: 24px; justify-content: space-between; height: 92px;' data-action='close'>
      <tag3-simple-button accent='keppel' device='mobile' button-style='{"width": "100%"}'>Yes</tag3-simple-button>  
      <tag3-tertiary-button accent='keppel' device='mobile' button-style='{"width": "100%", "border": "0"}'>No</tag3-tertiary-button>
    </div>
  </div>
</tag3-mobile-modal>
<tag3-simple-button data-action='open'>Open</tag3-simple-button>
`,
    js: `var closeButton = document.querySelector('[data-action="close"]');
var modal = document.querySelector('tag3-mobile-modal');
closeButton.addEventListener("buttonClick", function () {
  modal.open = false;
});
var openButton = document.querySelector('tag3-simple-button[data-action="open"]');
openButton.addEventListener("buttonClick", function () {
  modal.open = true;
});
modal.addEventListener("openChange", function (e) {
  modal.open = e.detail.open;
});
`,
  },
  reactWrapper_v3: {
    jsx: `<Example />`,
    parentJSX: `Example = () => {
  const [open, setOpen] = React.useState(false);

  return (
    <>
      <Tag3MobileModal open={open} onOpenChange={(e) => setOpen(e.detail.open)} contentStyle={{width: '90%'}}>
        <div style={{padding: "20px", display: "flex", flexDirection: "column"}}>
          Would you like to add another?
          <div style={{display: "flex", flexDirection: "column", alignItems: "stretch", justifyContent: "space-between", marginTop: "24px", height: "92px"}}>
            <Tag3SimpleButton accent='denim' device='mobile' onButtonClick={() => setOpen(false)} buttonStyle={{"width": "100%"}}>
              Close
            </Tag3SimpleButton>
            <Tag3TertiaryButton accent='denim' device='mobile' onButtonClick={() => setOpen(false)} buttonStyle={{"width": "100%", "border": "0"}}>
              No
            </Tag3TertiaryButton>
          </div>
        </div>
      </Tag3MobileModal>
      <Tag3SimpleButton
        onButtonClick={() => setOpen(true)}
      >
        Open
      </Tag3SimpleButton>
    </>
  )
}
  `,
  },
};

export const TagMobileModalDocs: Component = {
  type: 'component',
  name: 'mobile-modal',
  description: 'Renders a modal dialog for mobile apps.',
  mobileFriendly: true,
  popular: false,
  preRelease: '',
  props: [
    {
      name: 'open',
      description: 'Whether the modal is open',
      type: 'boolean',
    },
    {
      name: 'icon',
      description: 'An icon to display at the top of the modal above the heading (optional)',
      type: 'Icon | string',
    },
    {
      name: 'iconAccent',
      description: 'The accent colour for icon and its circle (optional)',
      type: 'string',
    },
    {
      name: 'heading',
      description: 'The heading for the modal',
      type: 'string',
    },
    {
      name: 'modalAriaLabel',
      description: 'A title for screen readers',
      type: 'string',
    },
    {
      name: 'modalAriaLabelledBy',
      description: 'An id of the title element for screen readers (alternative for modalAriaLabel)',
      type: 'string',
    },
    {
      name: 'modalAriaDescribedBy',
      description: 'An id of the description element for screen readers',
      type: 'string',
    },
    {
      name: 'colour-scheme',
      description:
        'Dark mode (theme) control. Undefined for normal browser control. Dark | Light to force respective styling regardless of browser setting.',
      type: 'dark | light',
    },
    {
      name: 'device',
      description: 'Set preferred styling theme for device type.',
      type: 'desktop | mobile',
      default: 'mobile',
    },
    {
      name: 'disable-background-dismiss',
      description: 'Set whether the modal will dismiss when you click on the background overlay',
      type: 'boolean',
      default: 'false',
    },
  ],
  reactPropOverrides: [],
  events: [
    {
      name: 'openChange',
      description: 'Raised when the modal is opened / closed',
      parameters: [
        {
          name: 'open',
          description: 'Whether the modal is open',
          type: 'boolean',
        },
      ],
    },
  ],
  methods: [],
  stories: [BasicStory, HeaderActionsStory, ContentStyleStory],
};
